const firstLetter = (word: string): string => (/\p{L}|\p{N}/u.exec(word)?.[0] ?? '').toLocaleUpperCase();

/**
 * First letter of the first and of the last word, upper-case; a single word gives its first two letters, '' when there is none.
 * Words split on spaces only, so one hyphenated surname stays one word. An e-mail address is read by its local part
 * (anna.bianchi@x.com is AB, giulia@x.com is GI). Every avatar uses this, so one person has the same initials on every screen.
 */
export function initials(label: string | null | undefined): string {
  const text = (label ?? '').trim();
  const words = (text.includes('@') ? text.split('@')[0]!.split(/[._-]+/) : text.split(/\s+/)).filter((word) => firstLetter(word));
  if (words.length === 0) return '';
  if (words.length === 1) {
    return Array.from(words[0]!)
      .filter((char) => firstLetter(char))
      .slice(0, 2)
      .join('')
      .toLocaleUpperCase();
  }
  return firstLetter(words[0]!) + firstLetter(words[words.length - 1]!);
}
